import { Instance, SnapshotIn, types } from "mobx-state-tree";

import { LengthUnits } from "convert-units/definitions/length";
import { SpeedUnits } from "convert-units/definitions/speed";
import { isoToSeconds, toSeconds } from "../shared/duration";
import SensorBase from "./SensorBase";
import { ISensor } from "./Sensors";
import { normalizeLengthUnit } from "../convert";

const {
  compose,
  frozen,
  literal,
  map,
  model,
  maybeNull,
  number,
  string,
  snapshotProcessor,
} = types;


export const toIntensity = (depth: number, interval: string): number =>
  depth * (toSeconds({ hours: 1 }) / isoToSeconds(interval));


const PrecipSensorModel = compose(
  SensorBase,
  model({
    type: literal("precip"),
    latest: maybeNull(string),
    unit: frozen<LengthUnits>(),
    depths: map(maybeNull(number)),
  }))
  .views((self) => ({
    get latestDate() {
      return self.latest ? new Date(self.latest) : null
    },
    get totalUnit() {
      return self.unit;
    },
    totalFor(interval: string) {
      return self.depths.get(interval) || null;
    },

    get intensityUnit() {
      return self.unit + "/h" as SpeedUnits;
    }

  }))
  .views((self) => ({
    intensityFor(interval: string) {
      const depth = self.totalFor(interval);
      if (depth === null) {
        return null;
      }
      return toIntensity(depth, interval);
    },
  }))
  .named("PrecipSensor");

const PrecipSensor = snapshotProcessor(PrecipSensorModel, {
  preProcessor(snapshot) {
    return {
      ...snapshot,
      unit: normalizeLengthUnit(snapshot.unit),
    }
  }
});

export default PrecipSensor;

export const isPrecipSensor = (sensor: ISensor | undefined): sensor is IPrecipSensor => sensor?.type === "precip";
export interface IPrecipSensor extends Instance<typeof PrecipSensor> { }
export interface PrecipSensor_ extends SnapshotIn<typeof PrecipSensor> { }